/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Typography, Chip } from '@mui/material';
import NumberUtils from 'commons/utils/numberUtils';
import { getPeriodTypeSingularLabel } from './periodTypeUtils';

const useStyles = makeStyles()((theme) => ({
  newPriceLabel: {
    color: 'white',
    marginRight: '4px',
  },
  oldPriceLabel: {
    color: 'white',
    marginRight: '4px',
    textDecoration: 'line-through',
    textDecorationThickness: '1px',
  },
  discountChip: {
    background: 'linear-gradient(45deg, hsla(256, 79%, 72%, 1) 30%, #22b8e5 90%)',
    color: 'white',
  },
  discountChipBlackFriday: {
    background: 'black',
    color: '#fbff00',
    fontWeight: 'bold',
  },
  discountChipNewYear: {
    background: '#2ED195',
    color: 'white',
    fontWeight: 'bold',
  },
  subBoxTextColor: {
    color: 'white',
  },
  planBoxTextColor: {
    color: 'white',
  },
}));

// COMPONENT
function DiscountCardForever({ stripePlan, discountInfo, isBlackFridayPromo, isNewYearPromo }) {
  const { classes } = useStyles();

  const { price: planPrice } = stripePlan;
  const { description, fixedAmountDiscount, percentageDiscount, specialLabel } = discountInfo;

  const isSpecialPromo = isBlackFridayPromo || isNewYearPromo;

  return (
    <div>
      <Typography variant="h4" gutterBottom component="span" className={classes.oldPriceLabel}>
        De: {NumberUtils.toCurrency(planPrice, 2)}
      </Typography>
      <div style={{ display: 'flex', flexDirection: 'row', justifyItems: 'center', alignItems: 'baseline' }}>
        <Typography variant="h2" gutterBottom component="span" className={classes.newPriceLabel}>
          Por:{' '}
          {percentageDiscount
            ? NumberUtils.toCurrency(planPrice - (planPrice * percentageDiscount) / 100, 2)
            : NumberUtils.toCurrency(planPrice - fixedAmountDiscount, 2)}
        </Typography>
        <Typography variant="h6" gutterBottom component="span" className={classes.planBoxTextColor}>
          {' '}
          / {getPeriodTypeSingularLabel(stripePlan.periodType)}
        </Typography>
      </div>
      <div>
        {description && (
          <Typography variant="h6" gutterBottom component="span" className={classes.subBoxTextColor}>
            &nbsp;{description}
          </Typography>
        )}
        &nbsp;
        {specialLabel && (
          <Chip
            label={specialLabel}
            className={
              isSpecialPromo
                ? isBlackFridayPromo
                  ? classes.discountChipBlackFriday
                  : classes.discountChipNewYear
                : classes.discountChip
            }
          />
        )}
      </div>
    </div>
  );
}

export default DiscountCardForever;
